export function getPositionalMetrics(arg1, arg2) {
    let position = typeof arg1 === "string" ? arg1 : (arg2?.position || arg2?.["d-o-b"] || "");
    let stats = typeof arg1 === "object" ? arg1 : arg2;
    const pos = (typeof position === "string" ? position : "").toLowerCase();
    if (pos.includes('goalkeeper')) {
        return [
            { label: 'Clean Sheets', value: stats?.cleanSheets || '0' },
            { label: 'Shots Saved', value: stats?.shotsSaved || '0' },
            { label: 'Important Saves', value: stats?.importantSaves || '0' },
            { label: 'Spectacular Saves', value: stats?.spectacularSaves || '0' }
        ];
    } else if (pos.includes('defender') || pos.includes('back')) {
        const tacklePct = stats?.totalTackles ? Math.round((stats.tacklesWon / stats.totalTackles) * 100) : 0;
        const aerialPct = stats?.totalAerialDuels ? Math.round((stats.aerialDuelsWon / stats.totalAerialDuels) * 100) : 0;
        return [
            { label: 'Tackles Won %', value: `${tacklePct}%` },
            { label: 'Aerial Duels Won %', value: `${aerialPct}%` },
            { label: 'Goal-line Clearances', value: stats?.clearances || '0' },
            { label: 'Interceptions', value: stats?.interceptions || '0' }
        ];
    } else if (pos.includes('midfield')) {
        return [
            { label: 'Pass Accuracy %', value: `${stats?.passAccuracy || '0'}%` },
            { label: 'Successful Dribbles', value: stats?.successfulDribbles || '0' },
            { label: 'Interceptions', value: stats?.interceptions || '0' },
            { label: 'Big Chances Created', value: stats?.chancesCreated || '0' }
        ];
    } else { // Forwards / Default
        return [
            { label: 'xG', value: stats?.xg?.toFixed(2) || '0.00' },
            { label: 'Big Chances Created', value: stats?.chancesCreated || '0' },
            { label: 'Shots on Target', value: stats?.shotsOnTarget || '0' },
            { label: 'Penalty Area Shots', value: stats?.touchesInBox || '0' }
        ];
    }
}

export function formatComparisonItems(player, benchmarks, isMember, type = 'value', stats = null) {
    const peerColors = ['rgba(79, 172, 254, 0.8)', 'rgba(255, 75, 43, 0.8)', 'rgba(168, 224, 99, 0.8)'];
    
    if (type === 'value') {
        if (!isMember) return [];
        return [
            ...benchmarks.map((b, idx) => ({
                name: b.name,
                value: (b.value > 100000 ? b.value / 1000000 : b.value),
                color: peerColors[idx % peerColors.length]
            })),
            {
                name: player.name,
                value: (parseFloat(player.base_value) > 100000 ? parseFloat(player.base_value) / 1000000 : parseFloat(player.base_value)),
                color: 'var(--gold)'
            }
        ].sort((a, b) => b.value - a.value);
    } else { // rating
        return [
            ...(benchmarks || []).map((b, idx) => ({
                name: b.name,
                rating: b.rating || 0,
                value: b.rating || 0,
                color: peerColors[idx % peerColors.length]
            })),
            {
                name: player.name,
                rating: stats?.rating || 0,
                value: stats?.rating || 0,
                color: 'var(--gold)'
            }
        ].sort((a, b) => b.value - a.value);
    }
}
